import Script from "next/script"
import { env } from "@/env/server"

export function AffonsoScript() {
  if (!env.AFFONSO_PROGRAM_ID) {
    throw new Error("AFFONSO_PROGRAM_ID is not set")
  }

  return (
    <Script
      async
      defer
      src="https://affonso.io/js/pixel.min.js"
      data-affonso={env.AFFONSO_PROGRAM_ID}
      data-cookie_duration="60"
      strategy="afterInteractive"
    />
  )
}
